<template>
    <front-layout title="Empresas">
        <div class="fixed top-0 left-0 w-full min-h-full block bg-opacity-80 z-50 bg-gray-900 pointer-events-none" v-if="showForm"></div>
    
            <div class="container mx-auto px-4 py-40">
                <div class="flex flex-col md:flex-row md:space-x-10 items-center min-h-[80vh]">
                    <div class="flex-1">
                        <img src="/images/empresas_img_1.png" alt="imagem" class="w-full">
                    </div>

                    <div class="flex-1 text-lg">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-html="empresas_text_1" v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" id="empresas_text_1" class="bg-white inline-block p-2 rounded-lg"></div>

                        <div v-html="empresas_text_1" v-else></div>
                    

                         <jet-button @click.prevent="showForm = true" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent focus:ring-violet-500 mt-8 group text-lg text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Consulte-nos <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></jet-button>
                    </div>
                </div>

                <div class="flex flex-col md:flex-row md:space-x-10 items-center min-h-[80vh] mt-8 lg:mt-0">

                    <div class="flex-1 text-lg">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-html="empresas_text_2" v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" id="empresas_text_2" class="bg-white inline-block p-2 rounded-lg"></div>

                        <div v-html="empresas_text_2" v-else></div>
                        
                        <jet-button @click.prevent="showForm = true" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent focus:ring-violet-500 mt-8 group text-lg text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Consulte-nos <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></jet-button>
                    </div>

                    <div class="flex-1">
                        <img src="/images/empresas_img_2.png" alt="imagem" class="w-full">
                    </div>
                    
                </div>
       
                <!-- form -->
                <div class="border fixed top-0 right-0 bg-white p-6 shadow-xl z-50 overflow-y-auto transition-all h-full w-full lg:w-1/2" :class="showForm ? 'right-0' : '-right-[100vw]'">
                      
                    <h3 class="font-bold">Aqui poderá pedir-nos mais informações, solicitar propostas ou agendar reuniões, sem qualquer compromisso.</h3>
                    <p class="text-gray-500 text-sm mt-2">Garantimos a confidencialidade dos dados que nos enviar, não sendo em momento algum divulgados a terceiros não autorizados.</p>

                
                    <form @submitted="formEmpresas" class="w-full border-t pt-8 overflow-y-auto">
                        <!-- Empresa -->
                        <div>
                            <div class="flex flex-row space-x-2">
                                <jet-label for="empresa" value="Empresa *" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.empresa" />
                            </div>
                           
                            <jet-input type="text" v-model="form.empresa" class="w-full"/>
                        </div>

                        <div class="flex space-x-4 w-full mt-2">
                             <!-- Website -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="website" value="Website" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.website" />
                                </div>
                                <jet-input type="text" v-model="form.website" class="w-full"/>
                                
                            </div>
                            <!-- Responsásel -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="responsavel" value="Responsável *" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.responsavel" />
                                </div>
                                <jet-input type="text" v-model="form.responsavel" class="w-full"/>
                                
                            </div>
                        </div>
                       
                        <!-- Morada -->
                        <div class="mt-2">
                            <div class="flex flex-row space-x-2">
                                <jet-label for="morada" value="Morada *" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.morada" />
                            </div>
                            <text-area-input v-model="form.morada" rows="3" class="w-full"></text-area-input>
                        </div>
                        <div class="flex space-x-4 w-full mt-2">
                            <!-- Cod postal -->
                            <div class="flex-2">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="cod_postal" value="Cód. Postal *" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.cod_postal" />
                                </div>
                                <jet-input type="text" v-model="form.cod_postal" class="w-full" placeholder="0000-000"/>
                            </div>
                            <div class="flex-auto">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="localidade" value="Localidade *" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.localidade" />
                                </div>
                                <jet-input type="text" v-model="form.localidade" class="w-full"/>
                            </div>
                        </div>

                        <div class="flex space-x-4 w-full mt-2">
                            <!-- Telefone -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="tel" value="Tel *" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.tel" />
                                </div>
                                <jet-input type="text" v-model="form.tel" class="w-full"/>
                                
                            </div>
                            <!-- Email -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="email" value="Email *" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.email" />
                                </div>
                                <jet-input type="text" v-model="form.email" class="w-full"/>
                            </div>
                        </div>
                        <!-- Habilitações -->
                        <div class="mt-2">
                            <div class="flex flex-row space-x-2">
                                <jet-label for="assunto" value="Assunto *" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.assunto" />
                            </div>
                             <select-input name="form.assunto" v-model="form.assunto" label="">
                                <option value="Informações gerais">Informações gerais</option>
                                <option value="Cotações">Cotações</option>
                                <option value="Agendamento de reunião">Agendamento de reunião</option>
                            </select-input>   
                        </div>
                        <!-- Experiencia profissional -->
                        <div class="mt-2">
                            <jet-label for="notas" value="Notas" class="font-bold text-xs" />
                            <text-area-input v-model="form.notas" rows="3" class="w-full"></text-area-input>
                            <jet-input-error :message="form.errors.notas" class="mt-2" />
                        </div>
                        <input type="hidden" v-model="pfield">
                    </form>
               

                    <div class="lg:mt-8 lg:flex items-center">
                        <div>
                            <jet-checkbox v-model="form.rgpd" class="mr-2" value=""></jet-checkbox> Li e aceito a <a :href="route('pol_privacidade')" class="text-violet-500 underline">Política de Privacidade</a>
                            <jet-input-error :message="form.errors.rgpd" />

                        </div>
                        <div class="flex flex-row justify-end flex-1">
                            <jet-secondary-button @click="cancel">Cancelar</jet-secondary-button>

                            <jet-button @click.prevent="formEmpresas" class="ml-2 bg-violet-500 hover:bg-violet-600">Enviar</jet-button>
                        </div>
                    </div>
                </div>
        </div>
    </front-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import Icon from '@/Jetstream/Icon.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import SelectInput from '@/Components/SelectInput'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            JetButton,
            JetModal,
            JetDialogModal,
            FrontLayout,
            Icon,
            JetInput,
            JetSecondaryButton,
            JetFormMain,
            JetLabel,
            JetInputError,
            TextAreaInput,
            SelectInput,
            JetCheckbox,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            empresas_text_1: String,
            empresas_text_2: String
        },
        data() {
            return {
                pfield: '',
                enableEdit: false,
                showForm: false,
                form: this.$inertia.form({
                    empresa: '',
                    website: '',
                    responsavel: '',
                    morada: '',
                    localidade: '',
                    cod_postal: '',
                    tel: '',
                    email: '',
                    assunto: null,
                    notas: '',
                    rgpd: ''
                }),
                page: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                })
            }
        },
        created(){
        },
        methods: {
            formEmpresas() {
                if(this.pfield == ''){
                    this.form.post(route('empresas.send'), {
                        preserveScroll: true,
                        onSuccess: () => (
                            this.form.reset(),
                            this.showForm = false
                        ),
                    }); 
                }

            },
            cancel() {
                this.form.reset()
                this.showForm = false
            },
            updateText(e) {
                this.page.setting = e.target.id
                this.page.content = e.target.innerHTML,
                this.page.route = this.route().current()
            },
            updateSettings(e) {
                if(this.page.setting != '' && this.page.content != '' & this.page.route != '') {
                    this.page.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.page.reset(),
                            this.$page.props.flash.success = 'Página atualizada'
                        }, 
                    })
                }
            },
        }
    })
</script>
